import React, { useState, useEffect, useRef } from "react"
import { CSSTransition, SwitchTransition } from "react-transition-group"
import s from "./Modals.module.scss"
// import cx from "classnames";
import Spin from "assets/images/fingers/swipe-right.png"
import DoubleTap from "assets/images/fingers/double-tap.png"
import SingleSwipe from "assets/images/fingers/single-swipe.png"
import DoubleSwipe from "assets/images/fingers/double-swipe.png"
import SwipeDown from "assets/images/fingers/swipe-down.png"
import Drag from "assets/images/fingers/drag.png"
import Doggo from "assets/images/fingers/doggo.png"

import Modal from "components/UI/Modal"

/*
INSTRUCTIONS: Pass an array containing 0 or more strings, just put the name of the desired
              modal into the array as a string, and each passed will be displayed. Modals with an X to close
              will be removed from array in the component. So pass the set function.

LIST OF MODALS:

tryPet
tryToy
throwStick
throwBall
trickSitPretty
tricksHint  //for Find unlocked tricks in menu
trickBackflip
trickSpin
trickSpeak
selfieHint  
closeAll //close all modals
selfieHint
newTrickCongrats
keepPetting
snapAndShare
followPrompts



*/

const url =
  process.env.NODE_ENV === "development"
    ? `https://${window.location.hostname}:3000/gestures`
    : `https://${window.location.hostname}/gestures`
const fingerModals = [
  {
    iframeSrc: `${url}/SwipeRight-2fing.html`,
    src: Spin,
    name: "trickSpin",
    title: "Do a trick: Spin",
    subtext: "Swipe right with two fingers.",
    extraCSS: {
      height: "200px",
    },
  },
  {
    iframeSrc: `${url}/SwipeDown.html`,
    src: SwipeDown,
    name: "trickSpeak",
    title: "Do a trick: Speak",
    subtext: "Swipe down with one finger.",
    extraCSS: {
      height: "218px",
    },
  },
  {
    iframeSrc: `${url}/SwipeUP.html`,
    src: SingleSwipe,
    name: "trickSitPretty",
    title: "Do a trick: Sit Pretty",
    subtext: "Swipe up with one finger.",
    extraCSS: {
      height: "218px",
    },
  },
  {
    iframeSrc: `${url}/SideSide.html`,
    src: Drag,
    name: "tryPet",
    title: "Pet Robo Dog",
    subtext: "Slide one finger back and forth on Robo Dog.",
    extraCSS: {
      height: "210px",
    },
  },
  {
    iframeSrc: `${url}/SwipeUP-2fing.html`,
    src: DoubleSwipe,
    name: "trickBackflip",
    title: "Do a trick: Back Flip",
    subtext: "Swipe up with two fingers.",
    extraCSS: {},
  },
  {
    iframeSrc: `${url}/doubletap.html`,
    src: DoubleTap,
    name: "selfieHint",
    title: "Pose for a selfie",
    subtext: "Tap with one finger",
    extraCSS: {
      height: "180px",
    },
  },
]

const modalContent = {
  tryToy: {
    line: "Try a toy",
    classNames: "tryToy",
  },
  throwBall: {
    line: "Flick upwards to throw the ball.",
    reverse: true,
    classNames: "flickUpwards",
  },
  snapAndShare: {
    line: "Now snap and share a photo",
    classNames: "snapAndShare",
  },
  throwStick: {
    line: "Flick upwards to throw the stick.",
    reverse: true,
    classNames: "flickUpwards",
  },
  findMenuTricks: {
    line: "Find unlocked tricks in the menu",
    reverse: true,
    classNames: "findMenuTricks",
  },
  findOpenSpace: {
    line: "Find an open flat space",
    classNames: "findOpenSpace",
    hideArrow: true,
  },
  followPrompts: {
    line: "Follow the prompts to unlock tricks.",
    classNames: "findOpenSpace",
    hideArrow: true,
  },
  newTrickCongrats: {
    close: true,
    heading: "Great Job!",
    line: "You've just learned a new trick",
    classNames: "congratulations",
    hideArrow: true,
  },
  processing: {
    line: "Processing...",
    classNames: "processing",
    hideArrow: true,
  },
  keepPetting: {
    line: "Keep petting and see what happens.",
    classNames: "findOpenSpace",
    hideArrow: true,
  },
  unlockDog: {
    close: true,
    heading: "Congrats!",
    line: "You've unboxed Robo Dog, let's see what he can do!",
    image: Doggo,
    alt: "Double Swipe",
    heading2: "Try interacting with Robo Dog",
    classNames: "unlockDog",
    hideArrow: true,
  },
}

export default function Modals({ modals }) {
  const [modal, setModal] = useState(null)
  const [iframeVisible, setiframeVisible] = useState(false)
  const nodeRef = useRef(null)
  useEffect(() => {
    setiframeVisible(false)
  }, [])
  useEffect(() => {
    if (modals[0] && modalContent[modals[0]]) {
      setModal(modals[0])
    } else {
      setModal(null)
    }
  }, [modals])

  return (
    <>
      <SwitchTransition mode={"out-in"}>
        <CSSTransition
          nodeRef={nodeRef}
          key={modal}
          classNames="fade"
          timeout={200}
          unmountOnExit
          appear
        >
          <div ref={nodeRef}>
            <Modal modal={modalContent[modal]} />
          </div>
        </CSSTransition>
      </SwitchTransition>

      {fingerModals.map(
        ({ title, subtext, src, name, iframeSrc, extraCSS }, index) => {
          return (
            <div
              className={`${s.tricks} ${modals.includes(name) ? s.active : ""}`}
              key={index.toString()}
            >
              <iframe
                style={{
                  ...extraCSS,
                  opacity: iframeVisible ? "1" : "0",
                  visibility: iframeVisible ? "visible" : "hidden",
                }}
                className={"iframe"}
                title={name}
                src={iframeSrc}
                onLoad={() => setiframeVisible(true)}
                scrolling="no"
                frameBorder="0"
              ></iframe>
              <h5>{title}</h5>
              <div>{subtext}</div>
            </div>
          )
        }
      )}
    </>
  )
}
